import React, { useState, useEffect } from "react";
import { Button, Modal, Space, Form, Input, Col, Row, Select } from "antd";

import apiUpdateDevice from "../../api/masterName/updateMaster";

const ModalEditMaster = ({
  closeModal,
  open,
  submitModal,
  dataMaster,
  master,
  authUser,
}) => {
  const [formData] = Form.useForm();
  const [openModal, setOpenModal] = useState(false);

  const handleCancel = () => {
    setOpenModal(false);
    closeModal();
  };

  const onFinish = (value) => {
    console.log(value);

    apiUpdateDevice(authUser, master, value, dataMaster["id"], (err, res) => {
      if (!err && res.statusCode === 200) {
        formData.resetFields();
        submitModal(true, res.statusCode);
        setOpenModal(false);
      } else {
        submitModal(false, res.statusCode);
      }
    });
  };

  const actionSetData = () => {
    formData.setFieldsValue(dataMaster);
  };

  useEffect(() => {
    actionSetData();
    if (open) {
      setOpenModal(open);
    }
  }, [open]);

  return (
    <Modal
      title={<div style={styles.title}>Edit Master</div>}
      open={openModal}
      onCancel={handleCancel}
      footer={null}
      width="550px"
    >
      <Form
        form={formData}
        onFinish={onFinish}
        initialValues={{
          name: "",
        }}
      >
        <Form.Item label="Name : " name="name">
          <Input placeholder="name" size="large" />
        </Form.Item>
        <Row justify="space-between">
          <Col>
            <Button style={styles.buttonCancel} onClick={handleCancel}>
              No
            </Button>
          </Col>
          <Col>
            <Button style={styles.buttonOk} type="primary" htmlType="submit">
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const styles = {
  title: {
    color: "#4F4F4F",
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "150%",
    marginBottom: "20px",
  },
  buttonOk: {
    borderRadius: "6px",
    border: "1px solid #FFC700",
    background: "#FFC700",
    boxShadow: "0px 2px 0px 0px rgba(0, 0, 0, 0.02)",
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: "400",
    width: "86px",
    height: "40px",
  },
  buttonCancel: {
    borderRadius: "6px",
    border: "1px solid rgba(0, 0, 0, 0.15)",
    background: "#FFF",
    boxShadow: "0px 2px 0px 0px rgba(0, 0, 0, 0.02)",
    color: "#2A5885",
    fontSize: "16px",
    fontWeight: "400",
    width: "86px",
    height: "40px",
  },
};

export default ModalEditMaster;
